import React from 'react';
import { createRoot } from 'react-dom/client';

import Filters from '@/components/Filters';

interface FiltersData {
  id: string;
  content: Record<string, unknown>;
  type: 'sale' | 'rental';
  selected: Record<string, unknown>;
  options: Record<string, unknown>;
}

export default (lang: string, data: FiltersData): void => {
  const container = document.getElementById(data.id);

  if (!container) {
    return;
  }

  const root = createRoot(container);

  root.render(
    <Filters
      lang={lang}
      content={data.content}
      type={data.type}
      selected={data.selected}
      options={data.options}
    />
  );
};
